export default __webpack_public_path__ + "static/media/slidermobile2.454924ec.jpg";